// extracted by mini-css-extract-plugin
export default {"black":"#000","primary":"#49aada","orange":"#eb9412","root":"Wtp2UVpj9eXXZYR0zIt3","icon":"pbdHqzsXRBd9q5v_lGxZ","left":"quA0OC9iChd3AZkzezGX"};